import React, { CSSProperties } from 'react'
import COLORS from '../styles/colors'

interface Props {
  titleColor?: string
  customContainerStyle?: any
}

const StoreButtons = (props: Props) => {
  return (
    <div style={styles.container(props.customContainerStyle)}>
      <p style={styles.title(props.titleColor)}>Baixe nas lojas</p>
      <div style={styles.imagesWrapper}>
        <a href='https://apps.apple.com/br/app/mellro/id1452914442' className='store'>
          <img
            style={styles.img}
            src='https://mellro.com/wp-content/themes/genemy/images/appstore.png'
            width='160'
            height='50'
            alt='Download na app store'
          />
        </a>
        <a href='https://play.google.com/store/apps/details?id=com.mellro.app' className='store'>
          <img
            style={styles.img}
            src='https://mellro.com/wp-content/themes/genemy/images/googleplay.png'
            width='160'
            height='50'
            alt='Get it on Google play'
          />
        </a>
      </div>
    </div>
  )
}

const styles = {
  container: (customStyle: any) => ({
    padding: '32px 16px',
    marginBottom: 32,
    ...customStyle,
  }),
  imagesWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    align: 'center',
  },
  title: (titleColor?: string) =>
    ({
      fontSize: '21px',
      textAlign: 'center',
      fontWeight: 700,
      marginBottom: 16,
      color: titleColor || COLORS.brand.primaryDark,
    } as CSSProperties),
  img: {
    margin: '16px 8px',
  },
}

export default StoreButtons
